
import Vue from 'vue'
import ResellerTable from '../components/resellers/ResellerTable.vue'

export default Vue.extend({
  components: { ResellerTable }
})
